// const noScroll = require('no-scroll');
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

const lockScroll = {
  methods: {
    lockScroll() {
      // console.log('--- LOCK SCROLL ---');
      // noScroll.on();
      // this.$store.commit('setContentTitleScrollLock', true);

      // window.innerWidth - document.body.offsetWidth
      // document.body.style.overflow = 'hidden';

      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (this.userAgent.device.isMobile) {
        if (this.$route.name.includes('Tremfya')) {
          this.$store.state.tremfyaScrollPos = top;
        } else {
          this.$store.state.psoriasisScrollPos = top;
        }
      }

      disableBodyScroll(document.body);

      this.$store.commit('UPDATE_LOCK_STATE', true);
    },
    unlockScroll() {
      // console.log('--- UNLOCK SCROLL ---');

      enableBodyScroll(document.body);
      // noScroll.off();
      // this.$store.commit('setContentTitleScrollLock', false);
      this.$store.commit('UPDATE_LOCK_STATE', false);
    }
  }
};

export default lockScroll;
